import React from 'react'
import { MenuItem, TextField } from '@common/material'
import { localizedStrings } from '@core/strings'
import { RegisterItemPropertyFormItemProps } from '@modules/registers/items/form/types'
import { Box, Flex, Text } from '@fundamentals'
import { Controller, useFormContext } from 'react-hook-form'

export const RegisterItemSelectPropertyFormItem: React.FC<
  RegisterItemPropertyFormItemProps
> = ({ property, registerItem, sx, disabled }) => {
  const { control } = useFormContext()
  const isDisabled =
    disabled || (!!registerItem && property.lockedAfterCreation)

  return (
    <Controller
      name={`${property.id}`}
      control={control}
      rules={{
        validate: (value) => !!value?.selectedOptionUuid || !property.required,
      }}
      render={({ field, formState: { errors } }) => {
        return (
          <TextField
            key={property.id}
            disabled={isDisabled}
            select
            sx={{
              mb: 2,
              flexGrow: 1,
              ...sx,
            }}
            data-test={`${property.type}-${property.name}`}
            label={property.name}
            placeholder={localizedStrings.typeHere}
            InputLabelProps={{ shrink: true }}
            error={!!Object.keys(errors).includes(`${property.id}`)}
            required={property.required}
            SelectProps={{
              value: field.value?.selectedOptionUuid
                ? field.value.selectedOptionUuid
                : 'noSelection',

              renderValue: (optionUuid) => {
                const selectValue = property.selectConfig.find(
                  (option) => option.uuid === optionUuid,
                )

                return optionUuid === 'noSelection' ? (
                  <Text>
                    {property.required
                      ? localizedStrings.pleaseSelect
                      : localizedStrings.na}
                  </Text>
                ) : (
                  <Flex alignItems='center'>
                    <Box
                      mr={1.5}
                      height={24}
                      width={24}
                      borderRadius='50%'
                      sx={{
                        background: selectValue?.colour,
                        opacity: 0.7,
                      }}
                    />
                    <Text>{selectValue.label}</Text>
                  </Flex>
                )
              },
            }}
            value={field.value?.selectedOptionUuid}
            onChange={(e) => {
              field.onChange({
                ...property,
                registerPropertyId: property.id,
                selectedOptionUuid: e.target.value
                  ? e.target.value
                  : 'noSelection',
              })
            }}
          >
            {[
              {
                label: property.required
                  ? localizedStrings.pleaseSelect
                  : localizedStrings.na,
                uuid: 'noSelection',
                key: '',
                colour: '',
              },
              ...property.selectConfig,
            ].map((option) => {
              return (
                <MenuItem key={option.uuid} value={option.uuid}>
                  <Flex alignItems='center'>
                    <Box
                      mr={1.5}
                      height={18}
                      width={18}
                      borderRadius='50%'
                      sx={{
                        background: option.colour,
                        opacity: 0.7,
                      }}
                    />
                    <Text>{option.label}</Text>
                  </Flex>
                </MenuItem>
              )
            })}
          </TextField>
        )
      }}
    />
  )
}
